(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["totwoo-mother-daughter-direct"] && !Shopify.designMode) return;
  try {
    

(() => {
  function initTotwooMotherDaughterDirect(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    let disposed = false;
    const cleanups = [];
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    }
    function dispose() {
      if (disposed) return;
      disposed = true;
      cleanups.reverse().forEach(fn => fn());
      root.dataset.initialized = 'false';
    }
    listen(document, 'shopify:section:unload', event => {
      if (event.target === root || event.target.contains(root)) dispose();
    });

    const copyButton = root.querySelector('.md-copy-code');
    if (copyButton) {
      listen(copyButton, 'click', async () => {
        const status = root.querySelector('.md-copy-status');
        let copied = false;
        try {
          await navigator.clipboard.writeText(copyButton.dataset.code);
          copied = true;
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = copyButton.dataset.code;
          field.style.cssText = 'position:fixed;top:0;left:-9999px';
          root.appendChild(field);
          field.select();
          try { copied = document.execCommand('copy'); } catch (fallbackError) {}
          field.remove();
          copyButton.focus();
        }
        if (!disposed) { status.textContent = copied ? copyButton.dataset.copied : copyButton.dataset.failed; copyButton.querySelector('[data-copy-label]').textContent = copied ? 'Copied ✓' : 'Copy'; }
      });
    }
    const heroVideo = root.querySelector('.md-hero-video');
    if (heroVideo) {
      let heroVisible = true;
      let manuallyPaused = false;
      let systemPaused = false;
      heroVideo.muted = true;
      const syncHeroPlayback = () => {
        if (disposed) return;
        if (document.hidden || !heroVisible) {
          if (!heroVideo.paused) {
            systemPaused = true;
            heroVideo.pause();
          }
        } else if (!manuallyPaused) {
          const playback = heroVideo.play();
          if (playback) playback.catch(() => {});
        }
      };
      listen(heroVideo, 'pause', () => {
        if (systemPaused) systemPaused = false;
        else if (heroVisible && !document.hidden) manuallyPaused = true;
      });
      listen(heroVideo, 'play', () => { manuallyPaused = false; });
      listen(document, 'visibilitychange', syncHeroPlayback);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          heroVisible = entries[0].isIntersecting;
          syncHeroPlayback();
        }, { threshold: 0.05 });
        observer.observe(heroVideo);
        cleanups.push(() => observer.disconnect());
      } else syncHeroPlayback();
      cleanups.push(() => heroVideo.pause());
    }

    const events = window.__totwooV11Events || [];
    window.__totwooV11Events = events;
    function record(event, detail = {}) {
      if (disposed) return;
      const payload = { event, experiment: 'mother_daughter_purchase_path', version: 'direct', ...detail, time: new Date().toISOString() };
      events.push(payload);
      if (events.length > 100) events.shift();
      window.dispatchEvent(new CustomEvent('totwoo:v11-event', { detail: payload }));
    }
    let cartPending = false;
    const checkoutForm = root.querySelector('[data-md-checkout-form]');
    const purchaseForms = Array.from(root.querySelectorAll('.md-direct-form'));
    const actionButtons = Array.from(root.querySelectorAll('[data-md-cart-action]'));
    const originallyDisabled = new Map(actionButtons.map(button => [button, button.disabled]));
    function setCartBusy(busy) {
      cartPending = busy;
      actionButtons.forEach(button => { button.disabled = busy || originallyDisabled.get(button); });
    }
    async function purchasePair(form, action, button) {
      if (cartPending || button.disabled || disposed) return;
      const status = form.querySelector('[data-md-cart-status]');
      const cartLink = form.querySelector('[data-md-cart-link]');
      const oldLabel = button.textContent;
      const variantId = form.elements.namedItem('id').value;
      const productKey = form.closest('[data-product]').dataset.product;
      status.textContent = action === 'buy' ? 'Preparing checkout…' : 'Adding your pair…';
      status.dataset.state = 'loading';
      cartLink.hidden = true;
      setCartBusy(true);
      form.setAttribute('aria-busy', 'true');
      button.textContent = action === 'buy' ? 'Please wait…' : 'Adding…';
      record(action === 'buy' ? 'direct_buy_click' : 'direct_add_click', { product: productKey, variant_id: variantId });
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);
      let checkoutStarted = false;
      let added = false;
      try {
        const response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          const error = new Error(result.description || result.message || 'This pair could not be added. Please check its availability.');
          error.cartRejected = true;
          throw error;
        }
        added = true;
        record('direct_add_success', { product: productKey, variant_id: variantId, quantity: 1, action });
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.querySelectorAll('.cart-link__bubble').forEach(bubble => bubble.classList.add('cart-link__bubble--visible'));
        if (action === 'buy') {
          status.textContent = 'Pair added. Opening checkout…';
          status.dataset.state = 'success';
          record('direct_checkout_redirect', { product: productKey, variant_id: variantId });
          HTMLFormElement.prototype.submit.call(checkoutForm);
          checkoutStarted = true;
        } else {
          status.textContent = 'Pair added to your cart.';
          status.dataset.state = 'success';
          cartLink.hidden = false;
        }
      } catch (error) {
        status.dataset.state = 'error';
        status.textContent = added ? 'Your pair was added. Open your cart to continue to checkout.'
          : error.cartRejected ? error.message
          : 'We could not confirm the update. Check your cart before trying again.';
        cartLink.hidden = false;
        record('direct_cart_error', { product: productKey, variant_id: variantId, action, confirmed_added: added });
      } finally {
        window.clearTimeout(timeout);
        form.removeAttribute('aria-busy');
        if (!checkoutStarted) {
          setCartBusy(false);
          button.textContent = oldLabel;
        }
      }
    }
    purchaseForms.forEach(form => {
      const addButton = form.querySelector('[data-md-cart-action="add"]');
      const buyButton = form.querySelector('[data-md-cart-action="buy"]');
      buyButton.hidden = false;
      listen(form, 'submit', event => {
        event.preventDefault();
        purchasePair(form, 'add', addButton);
      });
      listen(buyButton, 'click', () => purchasePair(form, 'buy', buyButton));
    });
    listen(window, 'pageshow', event => {
      if (!event.persisted) return;
      setCartBusy(false);
      actionButtons.forEach(button => { button.textContent = button.dataset.mdCartAction === 'buy' ? 'Buy now' : 'Add to cart'; });
      root.querySelectorAll('[data-md-cart-status]').forEach(status => { status.textContent = ''; });
    });

    root.querySelectorAll('[data-event]').forEach(link => {
      listen(link, 'click', () => record(link.dataset.event, {
        placement: link.dataset.placement,
        ...(link.dataset.product ? { product: link.dataset.product } : {})
      }));
    });
    root.querySelectorAll('.faq details').forEach(detail => {
      listen(detail, 'toggle', () => { if (detail.open) record('faq_open', { question: detail.dataset.faq }); });
    });
    root.querySelectorAll('img.md-managed-image:not(#demo-image), .product-image img, .gift-image img').forEach(img => {
      const fail = () => {
        img.hidden = true;
        const fallback = img.parentElement.querySelector('[data-image-fallback], .image-fallback');
        if (fallback) fallback.hidden = false;
      };
      listen(img, 'error', fail);
      if (img.complete && img.naturalWidth === 0) fail();
    });
    const demo = root.querySelector('#studio-demo');
    const image = root.querySelector('#demo-image');
    const status = root.querySelector('#demo-status');
    const toggle = root.querySelector('#demo-toggle');
    const fallback = root.querySelector('#demo-fallback');
    function mediaUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, document.baseURI);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
      } catch { return ''; }
    }
    const animation = mediaUrl(root.dataset.animation);
    const poster = mediaUrl(root.dataset.poster);
    if (!demo || !status || !toggle || !fallback) return;
    if (!image || !poster) {
      if (image) image.hidden = true;
      fallback.hidden = false;
      toggle.hidden = true;
      toggle.disabled = true;
      status.textContent = 'Product demonstration unavailable. See the setup guide.';
      return;
    }
    const posterSrcset = image.getAttribute('srcset') || '';
    const posterSizes = image.getAttribute('sizes') || '';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, userPaused = false, animationFailed = false, mediaFailed = false, playing = false;
    let currentSource = mediaUrl(image.getAttribute('src'));
    function setSource(next) {
      if (!next || disposed || mediaFailed || currentSource === next) return;
      currentSource = next;
      image.src = next;
    }
    function responsivePoster(play) {
      // An active poster srcset otherwise wins over animation.src in real browsers.
      if (play || !posterSrcset) image.removeAttribute('srcset');
      else image.setAttribute('srcset', posterSrcset);
      if (play || !posterSizes) image.removeAttribute('sizes');
      else image.setAttribute('sizes', posterSizes);
    }
    function renderDemo() {
      if (disposed) return;
      if (mediaFailed) {
        image.hidden = true;
        fallback.hidden = false;
        toggle.disabled = true;
        toggle.textContent = 'Unavailable';
        toggle.setAttribute('aria-label', 'Product demonstration unavailable');
        status.textContent = 'See the setup guide for help.';
        playing = false;
        return;
      }
      const play = Boolean(animation) && visible && !document.hidden && !reduceMotion.matches && !userPaused && !animationFailed;
      responsivePoster(play);
      setSource(play ? animation : poster);
      toggle.disabled = !animation || reduceMotion.matches || animationFailed;
      toggle.textContent = play ? 'Still image' : toggle.disabled ? 'Still image' : 'Play animation';
      toggle.setAttribute('aria-label', !animation ? 'Static cover shown'
        : reduceMotion.matches ? 'Static cover shown for reduced motion'
        : animationFailed ? 'Animation unavailable; static cover shown'
        : play ? 'Show the static cover image' : 'Play animation when the demonstration is in view');
      status.textContent = animationFailed ? 'Animation unavailable. Still image shown.'
        : reduceMotion.matches ? 'Still image shown for reduced motion.'
        : !animation || userPaused ? 'Still image shown.'
        : play ? 'Animation playing.' : 'Plays when the demonstration is in view.';
      if (play && !playing) record('product_demo_play');
      playing = play;
    }
    listen(image, 'error', () => {
      if (disposed || mediaFailed) return;
      if (animation && currentSource === animation && !animationFailed) {
        animationFailed = true;
        renderDemo();
      } else {
        mediaFailed = true;
        renderDemo();
      }
    });
    listen(toggle, 'click', () => {
      if (toggle.disabled || mediaFailed) return;
      userPaused = playing;
      record(userPaused ? 'product_demo_static' : 'product_demo_resume');
      renderDemo();
    });
    listen(document, 'visibilitychange', renderDemo);
    if (reduceMotion.addEventListener) listen(reduceMotion, 'change', renderDemo);
    else if (reduceMotion.addListener) {
      reduceMotion.addListener(renderDemo);
      cleanups.push(() => reduceMotion.removeListener(renderDemo));
    }
    if (animation && 'IntersectionObserver' in window) {
      const observer = new window.IntersectionObserver(entries => {
        if (disposed) return;
        const entry = entries.find(item => item.target === demo);
        if (entry) { visible = entry.isIntersecting; renderDemo(); }
      }, { rootMargin: '0px', threshold: 0 });
      observer.observe(demo);
      cleanups.push(() => observer.disconnect());
    } else if (animation) {
      let scheduled = false;
      const updateViewport = () => {
        if (scheduled || disposed) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          if (disposed) return;
          const rect = demo.getBoundingClientRect();
          visible = rect.bottom > 0 && rect.top < window.innerHeight;
          renderDemo();
        });
      };
      listen(window, 'scroll', updateViewport, { passive: true });
      listen(window, 'resize', updateViewport, { passive: true });
      updateViewport();
    }
    cleanups.push(() => {
      if (playing) {
        responsivePoster(false);
        image.src = poster;
      }
    });
    toggle.hidden = false;
    renderDemo();
    if (image.complete && image.naturalWidth === 0) {
      mediaFailed = true;
      renderDemo();
    }
  }
  document.querySelectorAll('.totwoo-mother-daughter-direct').forEach(initTotwooMotherDaughterDirect);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.totwoo-mother-daughter-direct').forEach(initTotwooMotherDaughterDirect);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["totwoo-mother-daughter-v12"] && !Shopify.designMode) return;
  try {
    
/* Body-only interaction. No commerce writes or external analytics. */
(() => {
  function initTotwooMotherDaughter(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    let disposed = false;
    const cleanups = [];
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    }
    function dispose() {
      if (disposed) return;
      disposed = true;
      cleanups.reverse().forEach(fn => fn());
      root.dataset.initialized = 'false';
    }
    listen(document, 'shopify:section:unload', event => {
      if (event.target === root || event.target.contains(root)) dispose();
    });

    const copyButton = root.querySelector('.md-copy-code');
    if (copyButton) {
      listen(copyButton, 'click', async () => {
        const status = root.querySelector('.md-copy-status');
        let copied = false;
        try {
          await navigator.clipboard.writeText(copyButton.dataset.code);
          copied = true;
        } catch (error) {
          const field = document.createElement('textarea');
          field.value = copyButton.dataset.code;
          field.style.cssText = 'position:fixed;top:0;left:-9999px';
          root.appendChild(field);
          field.select();
          try { copied = document.execCommand('copy'); } catch (fallbackError) {}
          field.remove();
          copyButton.focus();
        }
        if (!disposed) { status.textContent = copied ? copyButton.dataset.copied : copyButton.dataset.failed; copyButton.querySelector('[data-copy-label]').textContent = copied ? 'Copied ✓' : 'Copy'; }
      });
    }
    const heroVideo = root.querySelector('.md-hero-video');
    if (heroVideo) {
      let heroVisible = true;
      let manuallyPaused = false;
      let systemPaused = false;
      heroVideo.muted = true;
      const syncHeroPlayback = () => {
        if (disposed) return;
        if (document.hidden || !heroVisible) {
          if (!heroVideo.paused) {
            systemPaused = true;
            heroVideo.pause();
          }
        } else if (!manuallyPaused) {
          const playback = heroVideo.play();
          if (playback) playback.catch(() => {});
        }
      };
      listen(heroVideo, 'pause', () => {
        if (systemPaused) systemPaused = false;
        else if (heroVisible && !document.hidden) manuallyPaused = true;
      });
      listen(heroVideo, 'play', () => { manuallyPaused = false; });
      listen(document, 'visibilitychange', syncHeroPlayback);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          heroVisible = entries[0].isIntersecting;
          syncHeroPlayback();
        }, { threshold: 0.05 });
        observer.observe(heroVideo);
        cleanups.push(() => observer.disconnect());
      } else syncHeroPlayback();
      cleanups.push(() => heroVideo.pause());
    }

    const events = window.__totwooV11Events || [];
    window.__totwooV11Events = events;
    function record(event, detail = {}) {
      if (disposed) return;
      const payload = { event, ...detail, time: new Date().toISOString() };
      events.push(payload);
      if (events.length > 100) events.shift();
      window.dispatchEvent(new CustomEvent('totwoo:v11-event', { detail: payload }));
    }
    root.querySelectorAll('[data-event]').forEach(link => {
      listen(link, 'click', () => record(link.dataset.event, {
        placement: link.dataset.placement,
        ...(link.dataset.product ? { product: link.dataset.product } : {})
      }));
    });
    root.querySelectorAll('.faq details').forEach(detail => {
      listen(detail, 'toggle', () => { if (detail.open) record('faq_open', { question: detail.dataset.faq }); });
    });
    root.querySelectorAll('img.md-managed-image:not(#demo-image), .product-image img, .gift-image img').forEach(img => {
      const fail = () => {
        img.hidden = true;
        const fallback = img.parentElement.querySelector('[data-image-fallback], .image-fallback');
        if (fallback) fallback.hidden = false;
      };
      listen(img, 'error', fail);
      if (img.complete && img.naturalWidth === 0) fail();
    });
    const demo = root.querySelector('#studio-demo');
    const image = root.querySelector('#demo-image');
    const status = root.querySelector('#demo-status');
    const toggle = root.querySelector('#demo-toggle');
    const fallback = root.querySelector('#demo-fallback');
    function mediaUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, document.baseURI);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
      } catch { return ''; }
    }
    const animation = mediaUrl(root.dataset.animation);
    const poster = mediaUrl(root.dataset.poster);
    if (!demo || !status || !toggle || !fallback) return;
    if (!image || !poster) {
      if (image) image.hidden = true;
      fallback.hidden = false;
      toggle.hidden = true;
      toggle.disabled = true;
      status.textContent = 'Product demonstration unavailable. See the setup guide.';
      return;
    }
    const posterSrcset = image.getAttribute('srcset') || '';
    const posterSizes = image.getAttribute('sizes') || '';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, userPaused = false, animationFailed = false, mediaFailed = false, playing = false;
    let currentSource = mediaUrl(image.getAttribute('src'));
    function setSource(next) {
      if (!next || disposed || mediaFailed || currentSource === next) return;
      currentSource = next;
      image.src = next;
    }
    function responsivePoster(play) {
      // An active poster srcset otherwise wins over animation.src in real browsers.
      if (play || !posterSrcset) image.removeAttribute('srcset');
      else image.setAttribute('srcset', posterSrcset);
      if (play || !posterSizes) image.removeAttribute('sizes');
      else image.setAttribute('sizes', posterSizes);
    }
    function renderDemo() {
      if (disposed) return;
      if (mediaFailed) {
        image.hidden = true;
        fallback.hidden = false;
        toggle.disabled = true;
        toggle.textContent = 'Unavailable';
        toggle.setAttribute('aria-label', 'Product demonstration unavailable');
        status.textContent = 'See the setup guide for help.';
        playing = false;
        return;
      }
      const play = Boolean(animation) && visible && !document.hidden && !reduceMotion.matches && !userPaused && !animationFailed;
      responsivePoster(play);
      setSource(play ? animation : poster);
      toggle.disabled = !animation || reduceMotion.matches || animationFailed;
      toggle.textContent = play ? 'Still image' : toggle.disabled ? 'Still image' : 'Play animation';
      toggle.setAttribute('aria-label', !animation ? 'Static cover shown'
        : reduceMotion.matches ? 'Static cover shown for reduced motion'
        : animationFailed ? 'Animation unavailable; static cover shown'
        : play ? 'Show the static cover image' : 'Play animation when the demonstration is in view');
      status.textContent = animationFailed ? 'Animation unavailable. Still image shown.'
        : reduceMotion.matches ? 'Still image shown for reduced motion.'
        : !animation || userPaused ? 'Still image shown.'
        : play ? 'Animation playing.' : 'Plays when the demonstration is in view.';
      if (play && !playing) record('product_demo_play');
      playing = play;
    }
    listen(image, 'error', () => {
      if (disposed || mediaFailed) return;
      if (animation && currentSource === animation && !animationFailed) {
        animationFailed = true;
        renderDemo();
      } else {
        mediaFailed = true;
        renderDemo();
      }
    });
    listen(toggle, 'click', () => {
      if (toggle.disabled || mediaFailed) return;
      userPaused = playing;
      record(userPaused ? 'product_demo_static' : 'product_demo_resume');
      renderDemo();
    });
    listen(document, 'visibilitychange', renderDemo);
    if (reduceMotion.addEventListener) listen(reduceMotion, 'change', renderDemo);
    else if (reduceMotion.addListener) {
      reduceMotion.addListener(renderDemo);
      cleanups.push(() => reduceMotion.removeListener(renderDemo));
    }
    if (animation && 'IntersectionObserver' in window) {
      const observer = new window.IntersectionObserver(entries => {
        if (disposed) return;
        const entry = entries.find(item => item.target === demo);
        if (entry) { visible = entry.isIntersecting; renderDemo(); }
      }, { rootMargin: '0px', threshold: 0 });
      observer.observe(demo);
      cleanups.push(() => observer.disconnect());
    } else if (animation) {
      let scheduled = false;
      const updateViewport = () => {
        if (scheduled || disposed) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          if (disposed) return;
          const rect = demo.getBoundingClientRect();
          visible = rect.bottom > 0 && rect.top < window.innerHeight;
          renderDemo();
        });
      };
      listen(window, 'scroll', updateViewport, { passive: true });
      listen(window, 'resize', updateViewport, { passive: true });
      updateViewport();
    }
    cleanups.push(() => {
      if (playing) {
        responsivePoster(false);
        image.src = poster;
      }
    });
    toggle.hidden = false;
    renderDemo();
    if (image.complete && image.naturalWidth === 0) {
      mediaFailed = true;
      renderDemo();
    }
  }
  document.querySelectorAll('.totwoo-mother-daughter-v12').forEach(initTotwooMotherDaughter);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.totwoo-mother-daughter-v12').forEach(initTotwooMotherDaughter);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["totwoo-mother-daughter"] && !Shopify.designMode) return;
  try {
    
/* Body-only interaction. No commerce writes or external analytics. */
(() => {
  function initTotwooMotherDaughter(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    let disposed = false;
    const cleanups = [];
    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    }
    function dispose() {
      if (disposed) return;
      disposed = true;
      cleanups.reverse().forEach(fn => fn());
      root.dataset.initialized = 'false';
    }
    listen(document, 'shopify:section:unload', event => {
      if (event.target === root || event.target.contains(root)) dispose();
    });
    const events = window.__totwooV11Events || [];
    window.__totwooV11Events = events;
    function record(event, detail = {}) {
      if (disposed) return;
      const payload = { event, ...detail, time: new Date().toISOString() };
      events.push(payload);
      if (events.length > 100) events.shift();
      window.dispatchEvent(new CustomEvent('totwoo:v11-event', { detail: payload }));
    }
    root.querySelectorAll('[data-event]').forEach(link => {
      listen(link, 'click', () => record(link.dataset.event, {
        placement: link.dataset.placement,
        ...(link.dataset.product ? { product: link.dataset.product } : {})
      }));
    });
    root.querySelectorAll('.faq details').forEach(detail => {
      listen(detail, 'toggle', () => { if (detail.open) record('faq_open', { question: detail.dataset.faq }); });
    });
    root.querySelectorAll('img.md-managed-image:not(#demo-image), .product-image img, .gift-image img').forEach(img => {
      const fail = () => {
        img.hidden = true;
        const fallback = img.parentElement.querySelector('[data-image-fallback], .image-fallback');
        if (fallback) fallback.hidden = false;
      };
      listen(img, 'error', fail);
      if (img.complete && img.naturalWidth === 0) fail();
    });
    const demo = root.querySelector('#studio-demo');
    const image = root.querySelector('#demo-image');
    const status = root.querySelector('#demo-status');
    const toggle = root.querySelector('#demo-toggle');
    const fallback = root.querySelector('#demo-fallback');
    function mediaUrl(value) {
      if (!value) return '';
      try {
        const url = new URL(value, document.baseURI);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
      } catch { return ''; }
    }
    const animation = mediaUrl(root.dataset.animation);
    const poster = mediaUrl(root.dataset.poster);
    if (!demo || !status || !toggle || !fallback) return;
    if (!image || !poster) {
      if (image) image.hidden = true;
      fallback.hidden = false;
      toggle.hidden = true;
      toggle.disabled = true;
      status.textContent = 'Product demonstration unavailable. See the setup guide.';
      return;
    }
    const posterSrcset = image.getAttribute('srcset') || '';
    const posterSizes = image.getAttribute('sizes') || '';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, userPaused = false, animationFailed = false, mediaFailed = false, playing = false;
    let currentSource = mediaUrl(image.getAttribute('src'));
    function setSource(next) {
      if (!next || disposed || mediaFailed || currentSource === next) return;
      currentSource = next;
      image.src = next;
    }
    function responsivePoster(play) {
      // An active poster srcset otherwise wins over animation.src in real browsers.
      if (play || !posterSrcset) image.removeAttribute('srcset');
      else image.setAttribute('srcset', posterSrcset);
      if (play || !posterSizes) image.removeAttribute('sizes');
      else image.setAttribute('sizes', posterSizes);
    }
    function renderDemo() {
      if (disposed) return;
      if (mediaFailed) {
        image.hidden = true;
        fallback.hidden = false;
        toggle.disabled = true;
        toggle.textContent = 'Unavailable';
        toggle.setAttribute('aria-label', 'Product demonstration unavailable');
        status.textContent = 'See the setup guide for help.';
        playing = false;
        return;
      }
      const play = Boolean(animation) && visible && !document.hidden && !reduceMotion.matches && !userPaused && !animationFailed;
      responsivePoster(play);
      setSource(play ? animation : poster);
      toggle.disabled = !animation || reduceMotion.matches || animationFailed;
      toggle.textContent = play ? 'Still image' : toggle.disabled ? 'Still image' : 'Play animation';
      toggle.setAttribute('aria-label', !animation ? 'Static cover shown'
        : reduceMotion.matches ? 'Static cover shown for reduced motion'
        : animationFailed ? 'Animation unavailable; static cover shown'
        : play ? 'Show the static cover image' : 'Play animation when the demonstration is in view');
      status.textContent = animationFailed ? 'Animation unavailable. Still image shown.'
        : reduceMotion.matches ? 'Still image shown for reduced motion.'
        : !animation || userPaused ? 'Still image shown.'
        : play ? 'Animation playing.' : 'Plays when the demonstration is in view.';
      if (play && !playing) record('product_demo_play');
      playing = play;
    }
    listen(image, 'error', () => {
      if (disposed || mediaFailed) return;
      if (animation && currentSource === animation && !animationFailed) {
        animationFailed = true;
        renderDemo();
      } else {
        mediaFailed = true;
        renderDemo();
      }
    });
    listen(toggle, 'click', () => {
      if (toggle.disabled || mediaFailed) return;
      userPaused = playing;
      record(userPaused ? 'product_demo_static' : 'product_demo_resume');
      renderDemo();
    });
    listen(document, 'visibilitychange', renderDemo);
    if (reduceMotion.addEventListener) listen(reduceMotion, 'change', renderDemo);
    else if (reduceMotion.addListener) {
      reduceMotion.addListener(renderDemo);
      cleanups.push(() => reduceMotion.removeListener(renderDemo));
    }
    if (animation && 'IntersectionObserver' in window) {
      const observer = new window.IntersectionObserver(entries => {
        if (disposed) return;
        const entry = entries.find(item => item.target === demo);
        if (entry) { visible = entry.isIntersecting; renderDemo(); }
      }, { rootMargin: '0px', threshold: 0 });
      observer.observe(demo);
      cleanups.push(() => observer.disconnect());
    } else if (animation) {
      let scheduled = false;
      const updateViewport = () => {
        if (scheduled || disposed) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          if (disposed) return;
          const rect = demo.getBoundingClientRect();
          visible = rect.bottom > 0 && rect.top < window.innerHeight;
          renderDemo();
        });
      };
      listen(window, 'scroll', updateViewport, { passive: true });
      listen(window, 'resize', updateViewport, { passive: true });
      updateViewport();
    }
    cleanups.push(() => {
      if (playing) {
        responsivePoster(false);
        image.src = poster;
      }
    });
    toggle.hidden = false;
    renderDemo();
    if (image.complete && image.naturalWidth === 0) {
      mediaFailed = true;
      renderDemo();
    }
  }
  document.querySelectorAll('.totwoo-mother-daughter').forEach(initTotwooMotherDaughter);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.totwoo-mother-daughter').forEach(initTotwooMotherDaughter);
  });
})();


  } catch(e) { console.error(e); }
})();
})();
